import React from 'react';
import Heart from '../../img/heartemoji.png';
import Glasses from '../../img/glasses.png';
import Humble from '../../img/humble.png';
import './Services.css';
import Card from '../Card/Card';
import Resume from './KyawLwinSoeResume.pdf';
import {themeContext} from '../../Contest';
import {useContext} from 'react';
import {motion} from 'framer-motion';

function Services() {
  const transition = {duration: 2, type: 'spring'};
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode
  return (
    <div className='services' id='Services'>
      {/* Left Side */}
        <div className="awesome">
          <span style={{color: darkMode? 'white':''}} >My Awesome</span>
          <span>Services</span>
          <span > I'm Junior Web Developer and Web Designer. I can service in more technology field such as 
            Design Thinking, Design Creation, Graphic Design, Facebook Marketing and Digital Ecommerece Marketing. 
          </span>
          <a href={Resume} download>
          <button className="button s-button">
            Download CV
          </button>
          </a>
          <div className="blur s-blur1" style={{background:'#abf1ff94'}}></div>
        </div>
      {/* Right Side */}
        <div className="cards">
          <motion.div 
            initial={{left: '25rem'}}
            whileInView = {{left: '14rem'}}
            transition = {transition}
          
          style={{left:'14rem', top: '-8rem'}}>
            <Card 
            emoji = {Heart}
            heading = {'Design'}
            detail = {'Photoshop, Illustrator, Figma, Indesign, Adobe xd'}
            />
          </motion.div>

          <motion.div 
          initial={{left: '-20rem'}}
          whileInView={{left: '-4rem'}}
          transition={transition}
          
          style={{top: '5rem', left:'-4rem'}}>
            <Card 
            emoji = {Glasses}
            heading = {'Developer'}
            detail = {'HTML, CSS, JavaScript, PHP, React, Boostrap, jQuery'}
            />
          </motion.div>

          <motion.div 
          initial={{top: '-3rem'}}
          whileInView={{top: '9rem'}}
          transition={transition}
          
          style={{top:'23rem', left:'12rem'}}>
            <Card 
            emoji = {Humble}
            heading = {'Digital Maeketing'}
            detail = {'Digital Marketing such as Facebook Marketing, Boost Service and other Ecommerece Apps'}
            />
          </motion.div>
          <div className="blur s-blur1" style={{background: 'var(--purple)'}}></div>
        </div>
    </div>
  )
}

export default Services
